import styles from "./HeaderTitle.module.css";

interface HeaderTitleProps {
  title?: string;
}

export default function HeaderTitle({ title }: HeaderTitleProps): JSX.Element {
  return <div className={styles.title}>{title}</div>;
}
